import { all, call, cancel, fork, put, race, take } from 'redux-saga/effects';

// Types
import type { Saga } from 'redux-saga';

// Constants
import {
    SHARED_EVENT_LOAD_REQUESTED,
    SHARED_EVENT_LOAD_CANCELED
} from './constants';

// Actions
import {
    succeededLoadSharedEvent,
    failedLoadSharedEvent,
    setSharedEvent
} from './actions';

// Utils
import axiosPoll from '../../utils/axiosPoll';

// Environment
const { REACT_APP_API_URL } = process.env;

type Action = {
    +type: string,
    +payload: Object
};

export function* loadSharedEvent(action: Action): Saga<void> {
    const {
        payload: { eventUuid }
    } = action;

    yield call(axiosPoll, {
        config: {
            method: 'GET',
            url: `${REACT_APP_API_URL}/v1/Events/uuid/${eventUuid}/instructions`
        },
        succeeded: loadSharedEventSucceeded,
        failed: loadSharedEventFailed
    });
}

export function* loadSharedEventSucceeded(response: Object): Saga<void> {
    // Set Shared Event
    yield put(setSharedEvent(response.data));

    // Succeeded Load SharedEvent
    yield put(succeededLoadSharedEvent(response));
}

export function* loadSharedEventFailed(error: Error): Saga<void> {
    yield put(failedLoadSharedEvent(error));
}

export function* watchSharedEventLoadRequested(): Saga<void> {
    let lastTask;
    while (true) {
        const [requested] = yield race([
            take(SHARED_EVENT_LOAD_REQUESTED),
            take(SHARED_EVENT_LOAD_CANCELED)
        ]);

        if (lastTask) {
            yield cancel(lastTask);
        }
        if (requested) {
            lastTask = yield fork(loadSharedEvent, requested);
        }
    }
}

export default function* sharedEventSagas(): Saga<void> {
    yield all([fork(watchSharedEventLoadRequested)]);
}
